import {
  IntensitiesAction,
  IntensitiesState,
  UpdateIntensitiesAction,
} from "../types";

const initialState: IntensitiesState = {
  teamsById: {},
};
export const intensities = (
  state = initialState,
  action: UpdateIntensitiesAction
) => {
  switch (action.type) {
    case IntensitiesAction.UPDATE_INTENSITIES:
      return {
        ...state,
        teamsById: action.data,
      };
    default:
      return state;
  }
};
